const toast = document.createElement('div')
const toastText = document.createElement('span')
toast.appendChild(toastText)
let timer

// helpers ----------------------------------------------------------------
const setStyle = (el, styles) => {
  const s = el.style
  for (const key in styles) {
    // http://eslint.org/docs/rules/no-prototype-builtins
    // In ECMAScript 5.1, Object.create was added, which enables the creation of objects with a specified [[Prototype]].
    // Object.create(null) is a common pattern used to create objects that will be used as a Map.
    // This can lead to errors when it is assumed that objects will have properties from Object.prototype.
    // This rule prevents calling Object.prototype methods directly from an object.
    if (Object.prototype.hasOwnProperty.call(styles, key)) s[key] = styles[key]
  }
}

const close = (cb) => {
  toast.addEventListener('webkitTransitionEnd', function animate() {
    toast.removeEventListener('webkitTransitionEnd', animate)
    if (toast) toast.parentNode.removeChild(toast)
    cb && cb()
  })

  toast.style.opacity = 0
}

setStyle(toast, {
  'z-index': 1000,
  position: 'fixed',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  'text-align': 'center',
  opacity: 0,
  '-webkit-transition': 'opacity .3s linear',
  transition: 'opacity .3s linear'
})

setStyle(toastText, {
  'z-index': 1001,
  'box-sizing': 'border-box',
  position: 'fixed',
  left: '0',
  top: '50%',
  '-webkit-transform': 'translate(0 -50%)',
  transform: 'translate(0, -50%)',
  'word-wrap': 'break-word',
  'word-break': 'break-all',
  'max-width': '80%',
  padding: '10px',
  color: '#fff',
  'font-size': '14px',
  background: 'rgba(0, 0, 0, 0.7)',
  'border-radius': '5px',
  'line-height': '1.4',
  display: 'inline-block'
})

const API = (msg = '请输入toast内容', duration = 2500, cb = null) => {
  toastText.innerHTML = msg
  document.body.appendChild(toast)

  // 强制reflow
  document.body.clientWidth

  toastText.style.marginLeft = `${(document.documentElement.getBoundingClientRect().width - toastText.getBoundingClientRect().width) / 2}px`
  toast.style.opacity = 1

  if (timer) {
    clearTimeout(timer)
  }

  timer = setTimeout(() => {
    close(cb)
  }, duration)
}

export default API


// WEBPACK FOOTER //
// ./node_modules/@common/toast/src/index.js